import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "@/api/useApiClient";
import { listInputs } from "@/api";

export function InputBadge() {
  const client = useApiClient();
  const navigate = useNavigate();
  const [pendingCount, setPendingCount] = React.useState(0);

  // Stable client reference prevents interval reset loop on auth updates
  const clientRef = React.useRef(client);
  clientRef.current = client;

  const fetchInputs = React.useCallback(async () => {
    try {
      // GET /inputs returns only pending, unexpired requests (RW-1.4).
      const { data } = await listInputs({ client: clientRef.current, throwOnError: true });
      setPendingCount(data.items.length);
    } catch (err) {
      console.error("Failed to fetch pending inputs count", err);
    }
  }, []);

  React.useEffect(() => {
    fetchInputs();
    const interval = setInterval(fetchInputs, 15000);
    return () => clearInterval(interval);
  }, [fetchInputs]);

  if (pendingCount === 0) {
    return null;
  }

  return (
    <button
      type="button"
      className="flex items-center gap-1.5 px-2 py-0.5 border border-warning/30 bg-warning/5 text-warning hover:bg-warning/10 text-[10px] font-mono transition-colors focus-visible:outline-none"
      onClick={() => navigate("/inbox")}
      aria-label={`${pendingCount} pending inputs`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-warning animate-pulse" />
      <span>{pendingCount} NEEDS INPUT</span>
    </button>
  );
}
